import axios from 'axios'
import { format } from 'date-fns'

const BASE_URL = process.env.REACT_APP_NEXTERA_API

export interface OICSyncResponse {
  status: string
  correlationId: string
  message: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Payload shape may evolve
  payload: any
}

export const sendSafetyObservationToOIC = async (
  projectId: string,
  observationId: number,
  sourceUrl?: string,
): Promise<OICSyncResponse> => {
  const res = await axios.post(
    `${BASE_URL}/oracle/outbound/send_safety_observation`,
    {
      project_id: projectId,
      observation_id: observationId,
      ...(sourceUrl ? { source_url: sourceUrl } : {}),
    },
  )
  return res.data
}

export const sendProgressTrackerSnapshotToOIC = async (
  projectId: string,
  tracker: string,
  floor: string,
  observationDate: Date | null,
  sourceUrl?: string,
  viewpointSubIds?: number[],
  scopeLabel?: string,
): Promise<OICSyncResponse> => {
  const res = await axios.post(
    `${BASE_URL}/oracle/outbound/send_progress_tracker_snapshot`,
    {
      project_id: projectId,
      tracker,
      floor,
      ...(observationDate
        ? { observation_date: format(observationDate, 'yyyy-MM-dd') }
        : {}),
      ...(sourceUrl ? { source_url: sourceUrl } : {}),
      ...(viewpointSubIds && viewpointSubIds.length > 0
        ? { viewpoint_sub_ids: viewpointSubIds }
        : {}),
      ...(scopeLabel ? { scope_label: scopeLabel } : {}),
    },
  )
  return res.data
}

export const sendReportPdfToOIC = async (
  projectId: string,
  documentId: number,
  sourceUrl?: string,
): Promise<OICSyncResponse> => {
  const res = await axios.post(`${BASE_URL}/oracle/outbound/send_report_pdf`, {
    project_id: projectId,
    document_id: documentId,
    ...(sourceUrl ? { source_url: sourceUrl } : {}),
  })
  return res.data
}
